import PropTypes from 'prop-types';
import React from 'react';

const PolandSpecificHeader = ({ contactDetails }) => {
const customerId = contactDetails.find((vat) => vat?.TypeCode === 'Primary')?.ID;
    return (
      <>
        {customerId && (
        <>
          <p>{`Customer NIP: ${customerId}`}</p>
          <br />
        </>
        )}
      </>
    );
};

PolandSpecificHeader.defaultProps = {
    contactDetails: []
};

PolandSpecificHeader.propTypes = {
    contactDetails: PropTypes.arrayOf(PropTypes.shape()),
};

export default PolandSpecificHeader;
